export default "__VITE_ASSET__DtQZl3ja__"